/**
 * 时间戳转换时间
 * @param {Number} timestamp 时间戳
 * @param {Number} hasDay 是否包含天
 */
export const timestamp2Time = (timestamp = 0, hasDay = false) => {
    const second = timestamp < 0 ? 0 : timestamp
    if (second === 0) {
        return {
            d: 0,
            h: 0,
            m: 0,
            s: 0
        }
    } else {
        const d = Math.floor(second / 3600 / 24)
        const h = Math.floor(second / 3600 % 24)
        const m = Math.floor(second / 60 % 60)
        const s = Math.floor(second % 60)
        let result = {}
        /* 是否包含天 */
        if (hasDay) {
            result = {
                d,
                h,
                m,
                s
            }
        } else {
            result = {
                h: d * 24 + h,
                m,
                s
            }
        }
        return result
    }
}

/**
 * 调用：dateFormatter('YYYY-MM-DD HH:mm', '1995/02/15 13:55') // 1995-02-15 13:55
 * @param {String} formatter 格式
 * @param {Date} date 日期
 */
export const dateFormatter = (formatter, date) => {
    date = (date ? new Date(date) : new Date())
    const Y = date.getFullYear() + ''
    const M = date.getMonth() + 1
    const D = date.getDate()
    const H = date.getHours()
    const m = date.getMinutes()
    const s = date.getSeconds()
    return formatter.replace(/YYYY|yyyy/g, Y)
        .replace(/YY|yy/g, Y.substr(2, 2))
        .replace(/MM/g, (M < 10 ? '0' : '') + M)
        .replace(/DD/g, (D < 10 ? '0' : '') + D)
        .replace(/HH|hh/g, (H < 10 ? '0' : '') + H)
        .replace(/mm/g, (m < 10 ? '0' : '') + m)
        .replace(/ss/g, (s < 10 ? '0' : '') + s)
}
